import {Component, Input, OnInit} from '@angular/core';
import { ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { Store } from '@ngxs/store';
import { ConfigurationState,PostingDataResponseModel, EditPostingState, UpdatePosting, EditPostingFormNames } from 'remarketing-angular-library';
import { cloneDeep, get as _get, set as _set } from 'lodash';
import { takeUntil } from 'rxjs/operators';
import { PostingFormDirective } from '../posting-form/posting-form.directive';
import { TranslocoDirective, TranslocoService } from '@jsverse/transloco';
import { PostingAnalyticsHelperService } from '../../services/posting-analytics-helper.service';
import { CharacterCountComponent, CharacterCountDirective } from 'remarketing-ui-components-lib';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-additional-disclosures-form',
    templateUrl: './additional-disclosures-form.component.html',
    styleUrls: ['./additional-disclosures-form.component.scss'],
    imports: [TranslocoDirective, ReactiveFormsModule, CharacterCountComponent, CommonModule, CharacterCountDirective]
})
export class AdditionalDisclosuresFormComponent extends PostingFormDirective implements OnInit {
  readonly maxInspectionCmtsLength = 250;
  vehicleInfoInDisclosureForm: UntypedFormGroup;
  postingData: PostingDataResponseModel;
  characterCountData: any;
  @Input() postingTypeString: string;

  constructor(
    private readonly formBuilder: UntypedFormBuilder,
    private readonly store: Store,
    private readonly translocoService: TranslocoService,
    private readonly postingAnalyticsHelperService: PostingAnalyticsHelperService
  ) {
    super();
  }

  public trackFormChanges() {
    _set(
      this.postingData,
      'inventoryItem.inspectionReport.inspectionData.vehicle.smokerFlag',
      this.vehicleInfoInDisclosureForm.get('smokerFlag').value
    );
    _set(
      this.postingData,
      'inventoryItem.inspectionReport.inspectionData.comments',
      this.vehicleInfoInDisclosureForm.get('inspectionComments').value
    );
    this.store.dispatch(new UpdatePosting(this.postingData));
  }

  ngOnInit() {
    this.store
      .select(EditPostingState.updatedPosting)
      .pipe(takeUntil(this.destroyed$))
      .subscribe(postingData => {
        this.postingData = cloneDeep(postingData);
      });

    this.vehicleInfoInDisclosureForm = this.formBuilder.group({
      smokerFlag: [null],
      inspectionComments: ['']
    });

    this.vehicleInfoInDisclosureForm.patchValue({
      smokerFlag: _get(this.postingData, 'inventoryItem.inspectionReport.inspectionData.vehicle.smokerFlag', null)
    });
    this.vehicleInfoInDisclosureForm.patchValue({
      inspectionComments: _get(this.postingData, 'inventoryItem.inspectionReport.inspectionData.comments')
    });
    this.translocoService.selectTranslateObject('UIComponents').subscribe(translatedObj => {
      this.characterCountData = translatedObj.characterCount;
    });
    this.sendPageloadAnalyticsEvent();
  }

  sendPageloadAnalyticsEvent() {
    this.postingAnalyticsHelperService.sendPageloadAnalyticsEvent(
      this.store.selectSnapshot(ConfigurationState.configuration).tenantName,
      this.postingTypeString,
      EditPostingFormNames.DISCLOSURES_ADDITIONAL
    );
  }
}
